var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21875 1.28125V8.5C8.21875 9.60457 7.32332 10.5 6.21875 10.5H3.34375C2.23918 10.5 1.34375 9.60457 1.34375 8.5V1.28125",
    stroke: "#EC9A1E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5625 1.125H9",
    stroke: "#EC9A1E",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 3.15625V8.46875",
    stroke: "#EC9A1E",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 3.15625V8.46875",
    stroke: "#EC9A1E",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 3.15625V8.46875",
    stroke: "#EC9A1E",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71875 0.5H4.15625C3.98366 0.5 3.84375 0.639911 3.84375 0.8125C3.84375 0.985089 3.98366 1.125 4.15625 1.125H5.71875C5.89134 1.125 6.03125 0.985089 6.03125 0.8125C6.03125 0.639911 5.89134 0.5 5.71875 0.5Z",
    stroke: "#EC9A1E",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteOutlined);
export default __webpack_public_path__ + "static/media/icon-delete--outlined.0bb278b8098524fb66a9ef2b152fb682.svg";
export { ForwardRef as ReactComponent };